export default "__VITE_ASSET__ZDC_570y__"